import { render } from "./DoubleChevronsDownIcon.vue?vue&type=template&id=6c4cc0aa"
import script from "./DoubleChevronsDownIcon.vue?vue&type=script&lang=js"
export * from "./DoubleChevronsDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__